<form [formGroup]="changePasswordForm" class="modal-new-worker">
   <form-group title="{{'PROFILE.PASSWORD_CHANGE' | translate  }}">
      <field-holder>
         <mat-form-field appearance="outline">
            <input matInput [type]="passwordFieldType" formControlName="oldPassword" required />
            <button mat-icon-button matSuffix (click)="togglePasswordVisibility('1')" type="button">
               <mat-icon>{{ passwordFieldType === 'password' ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-label>{{ 'PROFILE.OLD_PASSWORD' | translate }}</mat-label>
            <mat-error *ngIf="changePasswordForm.get('oldPassword').hasError('required')">{{'PROFILE.OLD_PASSWORD_ERROR' | translate}}</mat-error>
            <mat-error *ngIf="changePasswordForm.get('oldPassword').hasError('noCyrillic')">{{'GLOBAL.PASSWORD.REQUERED_ERROR' | translate}}</mat-error>
         </mat-form-field>
      </field-holder>
      <field-holder>
         <mat-form-field appearance="outline">
            <input matInput [type]="passwordFieldType2" formControlName="newPassword" required />
            <button mat-icon-button matSuffix (click)="togglePasswordVisibility('2')" type="button">
               <mat-icon>{{ passwordFieldType2 === 'password' ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-label>{{ 'PROFILE.NEW_PASSWORD' | translate }}</mat-label>
            <mat-error *ngIf="changePasswordForm.get('newPassword').hasError('required'); else noCyrillic">{{'GLOBAL.PASSWORD.REQUERED_ERROR' | translate}}</mat-error>
            <ng-template #noCyrillic>
               <mat-error *ngIf="changePasswordForm.get('newPassword').hasError('noCyrillic'); else noLowerLetter">{{'GLOBAL.PASSWORD.LETTER_ERROR' | translate}}</mat-error>
            </ng-template>
            <ng-template #noLowerLetter>
               <mat-error *ngIf="changePasswordForm.get('newPassword').hasError('atLeastOneLower'); else noUpperLetter">{{'GLOBAL.PASSWORD.ONE_LOWER_LETTER' | translate}}</mat-error>
            </ng-template>
            <ng-template #noUpperLetter>
               <mat-error *ngIf="changePasswordForm.get('newPassword').hasError('atLeastOneUpper'); else minLength">{{'GLOBAL.PASSWORD.ONE_UPPER_LETTER' | translate}}</mat-error>
            </ng-template>
            <ng-template #minLength>
               <mat-error *ngIf="changePasswordForm.get('newPassword').hasError('minlength'); else needDigit">{{'GLOBAL.PASSWORD.MIN_LENGTH' | translate}}</mat-error>
            </ng-template>
            <ng-template #needDigit>
               <mat-error *ngIf="changePasswordForm.get('newPassword').hasError('needDigit'); else needSpecial">{{'GLOBAL.PASSWORD.NEED_DIGIT' | translate}}</mat-error>
            </ng-template>
            <ng-template #needSpecial>
               <mat-error *ngIf="changePasswordForm.get('newPassword').hasError('needSpecialChar'); else forbiddenPassword">{{'GLOBAL.PASSWORD.NEED_SPECIAL_CHAR' | translate}}</mat-error>
            </ng-template>
            <ng-template #forbiddenPassword>
               <!-- NEPOTREBNO ALI OSTAVLJENO UKOLIKO TREBA NEKA SIFRA DA SE ISKLJUCI  @AndrijaTrifunovic -->
               <mat-error *ngIf="changePasswordForm.get('newPassword').hasError('forbiddenPassword');">{{'GLOBAL.PASSWORD.FORBIDEN' | translate}}</mat-error>
            </ng-template>
         </mat-form-field>
      </field-holder>
      <field-holder>
         <mat-form-field appearance="outline">
            <input matInput [type]="passwordFieldType3" formControlName="newPasswordConfirm" required [errorStateMatcher]="matcher" />
            <button mat-icon-button matSuffix (click)="togglePasswordVisibility('3')" type="button">
               <mat-icon>{{ passwordFieldType3 === 'password' ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-label>{{ 'PROFILE.NEW_PASSWORD_CONFIRM' | translate }}</mat-label>
            <mat-error *ngIf="changePasswordForm.get('newPasswordConfirm').hasError('required')">{{'GLOBAL.PASSWORD.REQUERED_PASSWORD_AFFIRMATION_ERROR' | translate}}</mat-error>
            <mat-error *ngIf="changePasswordForm.hasError('notSame') && !changePasswordForm.get('newPasswordConfirm').hasError('required')">{{'GLOBAL.PASSWORD.NOT_MATCH' | translate}}</mat-error>
            <mat-error *ngIf="changePasswordForm.get('newPasswordConfirm').hasError('noCyrillic')">{{'GLOBAL.PASSWORD.LETTER_ERROR' | translate}}</mat-error>
         </mat-form-field>
      </field-holder>
   </form-group>
</form>
<form-footer>
   <button class="form-footer__button form-footer__button--secondary" (click)="closeDialog()" mat-flat-button color="secondary">{{ 'GLOBAL_ADMIN.CREATE_USER.CANCEL' | translate }}</button>
   <button class="form-footer__button form-footer__button--secondary" mat-flat-button color="primary" (click)="changePassword(changePasswordForm)" type="submit" [disabled]="!changePasswordForm.valid">
      {{ 'PROFILE.CHANGE_PASSWORD_SUBMIT' | translate }}
   </button>
</form-footer>
